import axios from 'axios'
import request from './index'

export const getIndexCarMap = (entityid) => {
  return request({
    url: '/screen/index/car/map',
    method: 'post',
    data: {
	  command_id:85,
	  entityId:entityid
    }
  })
}

export const getCarTraj = (carid) => {
  return request({
    url: '/screen/index/car/linear',
    method: 'post',
    data: {
	  command_id:86,
      carId:carid
    }
  })
}

export const getIndexCarInstant = (carid,cartypeid) => {
  return request({
    url: '/screen/index/car/realtime',
    method: 'post',
    data: {
	  command_id:85,
      carId:carid,
	  carType:cartypeid
    }
  })
}

export const getIndexCarCustom = (carid) => {
  return request({
    url: '/screen/index/car/custom',
    method: 'post',
    data: {
	  command_id:85,
	  carId:carid
    }
  })
}

export const getIndexCarCamera = (carid) => {
  return request({
    url: '/screen/index/car/camera',
    method: 'post',
    data: {
	  command_id:85,
	  carId:carid
    }
  })
}

export const cameraFtpPreview = (carId,filePath,fileId)=>{
    return request({
        url: '/screen/cameraFtpPre',
        method: 'post',
        data: {
          carId:carId,
          filePath:filePath,
          fileName:fileId
        },
        responseType: 'blob'
    })
}

export const mapTrajFtpPreview = (carId,flag,mapPackNum,fileId)=>{
    return request({
        url: '/screen/mapTrajFtpPre',
        method: 'post',
        data: {
          carId:carId,
		  mapFlag:flag,
          mapPackNum:mapPackNum,
          fileName:fileId
        },
        responseType: 'blob'
    })
}


// export const remoteTakePicture=(carId)=>{
//     return request({
//         url:'/remoteTake/remoteTakePicture',
//         method:'post',
//         data:{
//             command_id:"72",
//             carId:carId,
//             controlFlag:1
//         }
//     })
// }

// export const remoteTakeEmergency=(carId,cmd)=>{
//     return request({
//         url:'/remoteTake/remoteTakeEmergency',
//         method:'post',
//         data:{
//             command_id:"73",
//             carId:carId,
//             controlFlag:cmd
//         }
//     })
// }

export const getIndexCarWarning = (carid) => {
  return request({
    url: '/screen/index/car/warning',
    method: 'post',
    data: {
	  command_id:85,
	  carId:carid
    }
  })
}

export const getIndexCarWork = (carid) => {
  return request({
    url: '/screen/index/car/work',
    method: 'post',
    data: {
	  command_id:85,
	  carId:carid
    }
  })
}

export const getCarWorkOrder = (listQuery) => {
  return request({
    url: '/screen/index/car/workorder',
    method: 'post',
    data: {
	  command_id:85,
	  // workid:workid,
	  
	  workid: listQuery.workId,
	  pageIndex: listQuery.pageIndex,
	  pageSize: listQuery.pageSize
    },
  })
}

export const getCarTrajFromOrder = (carid,orderdetail) => {
  return request({
    url: '/screen/index/car/getLineFromWkOrder',
    method: 'post',
    data: {
	  command_id:85,
      carId:carid,
	  wktype:orderdetail.workType,
	  timeStart:orderdetail.timeStart,
	  timeEnd:orderdetail.timeEnd == null ? orderdetail.updateTime : orderdetail.timeEnd
    }
  })
}

export const getCarTrajFromWkStatus = (workId) => {
  return request({
    url: '/screen/index/car/getLineFromWkStatus',
    method: 'post',
    data: {
	  command_id:85,
	  workid: workId
    },
  })
}

